import buildCanvasQueryKey from './buildCanvasQueryKey';
import invalidateCanvasLists from './invalidateCanvasLists';
import type { InvalidateCanvasConnectionsParams } from '../types';

// A connection write shifts the connection list and the canvas doc's
// connectionCount, logs an activity event (connection_created/removed) and
// changes the connection count shown on the list cards. Items are untouched
// (unlike an item removal, which cascades into connections), so the
// connection/canvas/activity reads plus every list query are invalidated.
const invalidateCanvasConnections = ({
    queryClient,
    organizationId,
    canvasId,
}: InvalidateCanvasConnectionsParams): Promise<void> => {
    const affectedKeys = [
        buildCanvasQueryKey({ scope: 'connections', canvasId }),
        buildCanvasQueryKey({ scope: 'canvas', canvasId }),
        buildCanvasQueryKey({ scope: 'activity', canvasId }),
    ];

    return Promise.all([
        queryClient.invalidateQueries({
            predicate: query =>
                typeof query.queryKey === 'string' && affectedKeys.includes(query.queryKey),
        }),
        invalidateCanvasLists({ queryClient, organizationId }),
    ]).then(() => undefined);
};

export default invalidateCanvasConnections;
